<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn color="green" append-icon="mdi-pencil-outline" v-bind="props">
          Editar
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Editar Ator</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="nome"
                    required
                    label="Nome*"
                    :rules="nomeRules"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Atualizar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module EditAtorModal
 * @desc Modal com o formulário para a edição de um ator.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {string} [nome=''] - Nome do ator.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se o ator ainda
 * está sendo atualizado.
 */
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    nomeProp: {
      type: String,
      required: true,
    },
  },
  emits: ['atorEditado'],
  data: () => ({
    dialog: false,
    nome: '',
    isLoading: false,
    nomeRules: [
      (v) => !!v || 'Nome é obrigatório',
      (v) => (v && v.length <= 20) || 'Nome deve ter no máximo 20 caracteres',
    ],
  }),
  created() {
    this.nome = this.nomeProp;
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para editar um ator.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          // eslint-disable-next-line camelcase
          nome_ator: this.nome,
        };
        try {
          this.isLoading = true;
          const response = await axios.put(
            `${apiUrl}/api/v1/ator/${this.id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const idProjeto = this.$route.params.idProjeto;

          this.$toast.success(response.data.msg);
          this.$emit('atorEditado');
          this.$router.push(`/projects/${idProjeto}/ator`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
